import React, { Component } from 'react';
import { Span, Span2, Div, H1, P, ImgUploder, Rating, Opts } from './elemans/_elemans'
import { consts, icons } from '../services/_consts';
import CvMakerContext from '../services/app-context';

export class Template1 extends Component {
    static contextType = CvMakerContext;
    constructor(props) {
        super(props);
        this.state = props.cv;
    }
    defaultColor = '#dc3545';
    style = {
        las: {
            // background: 'gray',
            // padding: '3px',
            borderRadius: '5px',
            // color: 'white',
            margin: '0 4px',
            fontSize: '24px'
        }
    }

    componentDidMount() {
        if (this.state.color2 == "#ffff00") {
            this.setState({ color2: this.defaultColor });
        }
    }


    remove = (field, i) => this.props.onRemoveFromList(field, i);

    up = (field, i) => this.props.onMoveInList(field, i, 'up');

    down = (field, i) => this.props.onMoveInList(field, i, 'down');


    render() {
        return (
            <div className='row ' >
                <div className='col px-5 py-5'>
                    <div className='text-center'>
                        <div className="row mb-2">
                            {this.state.showAvatar && <div className="col-5 text-end">

                                <ImgUploder avatar={this.state.avatar}
                                    maxSize="160000"
                                    onChanged={f => {
                                        if (!this.props.readonly) {
                                            this.setState({ avatar: f });
                                            this.props.handleChange('avatar', f);
                                        }
                                    }}
                                    style={{ width: '70px', height: '70px', borderRadius: '50%', border: `1px solid ${this.state.color2}44` }}
                                />
                            </div>}
                            <div className={(this.state.showAvatar ? "col-7 text-start" : "col text-center")}>
                                <H1 onBlur={e => this.props.onContentChanged(e, 'fullName')} >{this.state.fullName}</H1>
                                {this.state.showMySmallDesc && < Div onBlur={e => this.props.onContentChanged(e, 'mySmallDesc')}>{this.state.mySmallDesc}</Div>}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3 text-end"> <i></i>
                            </div>
                            <div className="col-9 text-start" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }} >

                                <Span2 showCondition={this.state.showBirthDate} style={{ color: this.state.color2 }} icon={icons.birthDate}
                                    onBlur={e => this.props.onContentChanged(e, 'birthDate')}
                                    onRemove={() => this.remove('showBirthDate')} >
                                    {this.state.birthDate}
                                </Span2>

                                <Span2 style={{ color: this.state.color2 }} icon={icons.mapMarker}
                                    onBlur={e => this.props.onContentChanged(e, 'address')} >
                                    {this.state.address}
                                </Span2>

                                <Span2 style={{ color: this.state.color2 }} icon={icons.phone}
                                    onBlur={e => this.props.onContentChanged(e, 'tel')} >
                                    {this.state.tel}
                                </Span2>

                                <Span2 style={{ color: this.state.color2 }} icon={icons.at}
                                    onBlur={e => this.props.onContentChanged(e, 'email')}
                                    onRemove={() => this.remove('email')} >
                                    {this.state.email}
                                </Span2>

                                <Span2 showCondition={this.state.showSite} style={{ color: this.state.color2 }} icon={icons.link}
                                    onBlur={e => this.props.onContentChanged(e, 'site')}
                                    onRemove={() => this.remove('showSite')} >
                                    {this.state.site}
                                </Span2>

                                <Span2 showCondition={this.state.showGithub} style={{ color: this.state.color2 }} icon={icons.github}
                                    onBlur={e => this.props.onContentChanged(e, 'github')}
                                    onRemove={() => this.remove('showGithub')} >
                                    {this.state.github}
                                </Span2>

                                <Span2 showCondition={this.state.showLinkedIn} style={{ color: this.state.color2 }} icon={icons.linkdIn}
                                    onBlur={e => this.props.onContentChanged(e, 'linkeIn')}
                                    onRemove={() => this.remove('showLinkedIn')} >
                                    {this.state.linkeIn}
                                </Span2>

                                <Span2 showCondition={this.state.showMarriage} style={{ color: this.state.color2 }} icon={icons.marriage}
                                    onBlur={e => this.props.onContentChanged(e, 'marriage')}
                                    onRemove={() => this.remove('showMarriage')} >
                                    {this.state.marriage}
                                </Span2>

                                <Span2 showCondition={this.state.showMilitaryService} style={{ color: this.state.color2 }} icon={icons.militaryService}
                                    onBlur={e => this.props.onContentChanged(e, 'militaryService')}
                                    onRemove={() => this.remove('showMilitaryService')} >
                                    {this.state.militaryService}
                                </Span2>


                            </div>
                        </div>

                    </div>

                    {this.state.showSummery &&
                        <div className='mt-3 Summery'>
                            <div className='sectionHead aviny' style={{ borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleSummery')} className='h6 aviny'>{this.state.titleSummery}</Span>
                            </div>
                            <P onBlur={e => this.props.onContentChanged(e, 'summery')} >{this.state.summery}</P>
                            {/*<div contentEditable dangerouslySetInnerHTML={{ __html: this.state.summery }}></div>*/}

                        </div>
                    }

                    {this.state.educations.length > 0 &&
                        <div className='mt-4 Educations'>
                            <div className='sectionHead aviny' style={{ borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleEducations')} className='h6 aviny'>{this.state.titleEducations}</Span>
                                {this.props.readonly || <button onClick={() => { this.setState({ educations: [...this.state.educations, consts.educationsTemp] }) }} className="add-btn noPrint">{consts.add}</button>}
                            </div>
                            <div>
                                <ul>
                                    {this.state.educations.map((x, i) =>
                                        <li key={i} className="pt-2" id={`educations${i}`}>
                                            <Span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'level')} className='pe-4' style={{ color: this.state.color2 }} >{x.level}</Span>
                                            <Span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'year')}  >{x.year}</Span> -
                                            <Span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'university')} >{x.university}</Span> –
                                            <Span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'city')} >{x.city}</Span> –
                                            <Span onBlur={e => this.props.onContentEditedInList(e, 'educations', i, 'field')} >{x.field}</Span>

                                            {this.props.readonly ||
                                                <Opts i={i} length={this.state.educations.length}
                                                    onUp={() => this.up('educations', i)}
                                                    onDown={() => this.down('educations', i)}
                                                    onRemove={() => this.remove('educations', i)}
                                                />}
                                        </li>)}
                                </ul>
                            </div>
                        </div>
                    }

                    <div className='mt-4 Skills'>
                        <div className='sectionHead aviny' style={{ borderBottom: `1px solid ${this.state.color2}` }}>
                            <Span onBlur={e => this.props.onContentChanged(e, 'titleSkills')} className='h6 aviny'>{this.state.titleSkills}</Span>
                            {this.props.readonly || <button onClick={() => { this.setState({ skills: [...this.state.skills, consts.skillsTemp] }) }} className="add-btn noPrint">{consts.add}</button>}
                        </div>
                        <div className='pt-2' style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
                            {this.state.skills.map((x, i) =>
                                <div id={`skills${i}`}
                                    style={{ borderRadius: '5px', border: `0px solid ${this.state.color2}`, margin: '2px', display: 'inline-block', paddingRight: '29px' }} key={i}>
                                    <Rating
                                        rateOf10={x.rateOf10} showRating={this.state.showSkillRating}
                                        onBlur={e => this.props.onContentEditedInList(e, 'skills', i, 'title')}
                                        ocRatechange={(e, r) => this.props.onRatechange(e, 'skills', i, r)}
                                        retedcolor={this.state.color2}

                                    >{x.title}</Rating>
                                    {this.props.readonly ||
                                        <Opts i={i} length={this.state.skills.length} type="leftRight"
                                            onUp={() => this.up('skills', i)}
                                            onDown={() => this.down('skills', i)}
                                            onRemove={() => this.remove('skills', i)}
                                        />}

                                </div>
                            )}
                        </div>
                    </div>

                    {this.state.workExperinces.length > 0 &&
                        <div className='mt-4 Work Experince'>
                            <div className='sectionHead aviny' style={{ borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleWorkExperince')} className='h6 aviny'>{this.state.titleWorkExperince}</Span>
                                {this.props.readonly || <button onClick={() => { this.setState({ workExperinces: [...this.state.workExperinces, consts.workExperincesTemp] }) }} className="add-btn noPrint">{consts.add}</button>}
                            </div>
                            <div>
                                <ul>
                                    {this.state.workExperinces.map((x, i) =>
                                        <li key={i} id={`workExperinces${i}`} className={i > 0 && "mt-2"}>
                                            <span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'name')} className='me-3' style={{ color: this.state.color2 }} contenteditable="true">{x.name}</span>
                                            <div className='text-gray me-3 float-end'>
                                                <Span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'from')} className='text-gray aviny'>{x.from}</Span> -
                                                <Span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'until')} className='text-gray aviny'>{x.until}</Span>
                                            </div>

                                            {this.props.readonly ||
                                                <Opts i={i} length={this.state.workExperinces.length}
                                                    onUp={() => this.up('workExperinces', i)}
                                                    onDown={() => this.down('workExperinces', i)}
                                                    onRemove={() => this.remove('workExperinces', i)}
                                                />}
                                            <div className='ms-4'>
                                                <span onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'title')} contenteditable="true" style={{ fontWeight: 'bold' }}>{x.title}</span>
                                                <Div onBlur={e => this.props.onContentEditedInList(e, 'workExperinces', i, 'desc')} >{x.desc}</Div>
                                            </div>
                                        </li>)}
                                </ul>
                            </div>
                        </div>
                    }

                    {this.state.freelanceProjects.length > 0 &&
                        <div className='mt-4 FreelanceProject'>
                            <div className='sectionHead aviny' style={{ borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleFreelanceProjects')} className='h6 aviny'>{this.state.titleFreelanceProjects}</Span>
                                {this.props.readonly || <button onClick={() => { this.setState({ freelanceProjects: [...this.state.freelanceProjects, consts.freelanceProjectsTemp] }) }} className="add-btn noPrint">{consts.add}</button>}
                            </div>
                            <div>
                                <ul>
                                    {this.state.freelanceProjects.map((x, i) =>
                                        <li key={i} id={`freelanceProjects${i}`} className={i > 0 && "mt-2"}>
                                            <span onBlur={e => this.props.onContentEditedInList(e, 'freelanceProjects', i, 'name')} className=' me-3' style={{ color: this.state.color2 }} contenteditable="true">{x.name}</span>
                                            {this.props.readonly ||
                                                <Opts i={i} length={this.state.freelanceProjects.length}
                                                    onUp={() => this.up('freelanceProjects', i)}
                                                    onDown={() => this.down('freelanceProjects', i)}
                                                    onRemove={() => this.remove('freelanceProjects', i)}
                                                />}                                              <div className='ms-4'>
                                                <Div onBlur={e => this.props.onContentEditedInList(e, 'freelanceProjects', i, 'desc')} >{x.desc}</Div>
                                            </div>
                                        </li>)}
                                </ul>
                            </div>
                        </div>
                    }

                    {this.state.languages.length > 0 &&
                        <div className='mt-4 Languages' id="languages">
                            <div className='sectionHead aviny' style={{ borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleLanguages')} className='h6 aviny'>{this.state.titleLanguages}</Span>
                                {this.props.readonly || <button onClick={() => { this.setState({ languages: [...this.state.languages, consts.languagesTemp] }) }} className="add-btn noPrint">{consts.add}</button>}
                            </div>
                            <div className='pt-2'>
                                {this.state.languages.map((x, i) =>
                                    <div id={`languages${i}`}
                                        style={{ borderRadius: '5px', border: `0px solid ${this.state.color2}`, margin: '2px', display: 'inline-block', paddingRight: '29px', marginLeft:'4px' }} key={i}>
                                        <Rating showRating={this.state.showLanguageRatting}
                                            rateOf10={x.rateOf10}
                                            maxValue='5'
                                            onBlur={e => this.props.onContentEditedInList(e, 'languages', i, 'title')}
                                            ocRatechange={(e, r) => this.props.onRatechange(e, 'languages', i, r)}
                                            retedcolor={this.state.color2}
                                        >{x.title}</Rating>
                                        {this.props.readonly ||
                                            <Opts i={i} length={this.state.languages.length} type="leftRight"
                                                onUp={() => this.up('languages', i)}
                                                onDown={() => this.down('languages', i)}
                                                onRemove={() => this.remove('languages', i)}
                                            />}
                                    </div>
                                )}
                            </div>
                        </div>
                    }

                    {this.state.certificates.length > 0 &&
                        <div className='mt-4 Certificates' id="certificates">
                            <div className='sectionHead' style={{ borderBottom: `1px solid ${this.state.color2}` }}>
                                <Span onBlur={e => this.props.onContentChanged(e, 'titleCertificates')} className='h6 aviny'>{this.state.titleCertificates}</Span>
                                {this.props.readonly || <button onClick={() => { this.setState({ certificates: [...this.state.certificates, consts.certificatesTemp] }) }} className="add-btn noPrint">{consts.add}</button>}
                            </div>
                            <div>
                                <ul>
                                    {this.state.certificates.map((x, i) =>
                                        <li key={i} id={`certificates${i}`} className={i > 0 && "mt-2"}>
                                            <Span onBlur={e => this.props.onContentEditedInList(e, 'certificates', i, 'title')} className='me-3' style={{ color: this.state.color2 }}><i className="las la-certificate" style={this.style.las}></i>{x.title}</Span>
                                            <Span onBlur={e => this.props.onContentEditedInList(e, 'certificates', i, 'date')} className='text-gray me-3 float-end aviny'>{x.date}</Span>
                                            {this.props.readonly ||
                                                <Opts i={i} length={this.state.certificates.length}
                                                    onUp={() => this.up('certificates', i)}
                                                    onDown={() => this.down('certificates', i)}
                                                    onRemove={() => this.remove('certificates', i)}
                                                />}                                              <div className='ms-4'>
                                                <Div onBlur={e => this.props.onContentEditedInList(e, 'certificates', i, 'desc')} >{x.desc}</Div>
                                            </div>
                                        </li>)}
                                </ul>
                            </div>
                        </div>
                    }
                </div>

            </div >
        );
    }
}
